import { render, staticRenderFns } from "./SystemLevelsRevisions.vue?vue&type=template&id=4954cc6a&scoped=true&"
import script from "./SystemLevelsRevisions.vue?vue&type=script&lang=js&"
export * from "./SystemLevelsRevisions.vue?vue&type=script&lang=js&"
import style0 from "./SystemLevelsRevisions.vue?vue&type=style&index=0&id=4954cc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954cc6a",
  null
  
)

export default component.exports